function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconPaymentMethodMobileFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M4.037 23.282V6.637H16.52v3.901c.666-.26 1.361-.459 2.08-.591v-5.39a3.12 3.12 0 00-3.12-3.121H5.077a3.12 3.12 0 00-3.12 3.12v20.807a3.12 3.12 0 003.12 3.12h6.777a11.398 11.398 0 01-2.427-5.201h-5.39z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.044 21.201a9.363 9.363 0 01-9.363 9.363 9.363 9.363 0 110-18.725 9.363 9.363 0 019.363 9.362zm-12.792 3.316v-1.582h2.412v-.922h-2.412v-1.595h1.478L16.52 16h2.398l1.827 4.418L22.612 16h2.23l-2.203 4.418h1.465v1.595h-2.398v.922h2.398v1.595h-2.398v1.873H19.69v-1.886h-2.439z",
    fill: props.color
  }));
}

export default SvgIconPaymentMethodMobileFilled;